import React from "react";
import Card from "./Card";
import Icon from "./Icon";
import Badge from "./Badge";
import Button from "./Button";

export function DocumentCard({ document, categoryLabel, onView, onDownload, onDelete }) {
  if (!document) return null;

  return (
    <Card className="doc-card">
      <div className="doc-meta">
        <div className="stack-inline">
          <Icon name="pdf" size={22} />
          <div className="doc-name">{document.name}</div>
        </div>
        <div className="muted">
          {document.size} • {document.date}
        </div>
        {categoryLabel && <Badge variant="primary">{categoryLabel}</Badge>}
      </div>
      <div className="muted doc-description">{document.description}</div>
      <div className="doc-actions">
        <Button
          variant="secondary"
          size="sm"
          iconLeft={<Icon name="view" size={16} />}
          onClick={() => onView?.(document)}
        >
          View
        </Button>
        <Button
          variant="secondary"
          size="sm"
          iconLeft={<Icon name="download" size={16} />}
          onClick={() => onDownload?.(document)}
        >
          Download
        </Button>
        <button
          type="button"
          className="icon-action danger"
          aria-label="Delete document"
          onClick={() => onDelete?.(document)}
        >
          <Icon name="trash" size={16} />
        </button>
      </div>
    </Card>
  );
}

export default DocumentCard;
